// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function getNetworkState() {
  let conn = navigator.connection;
  if (conn == null) {
    return "NOT_AVAILABLE";
  } else {
    return {
      TAG: "Value",
      _0: {
        isOnline: navigator.onLine,
        effectiveType: conn.effectiveType,
        downlink: conn.downlink,
        rtt: conn.rtt
      }
    };
  }
}

function useNetworkInformation() {
  let match = React.useState(() => "NOT_AVAILABLE");
  let setNetworkState = match[1];
  React.useEffect(() => {
    let updateNetState = () => {
      let conn = navigator.connection;
      if (conn == null) {
        return setNetworkState(param => "NOT_AVAILABLE");
      } else {
        return setNetworkState(param => ({
          TAG: "Value",
          _0: {
            isOnline: navigator.onLine,
            effectiveType: conn.effectiveType,
            downlink: conn.downlink,
            rtt: conn.rtt
          }
        }));
      }
    };
    window.addEventListener("load", updateNetState);
    window.addEventListener("online", updateNetState);
    window.addEventListener("offline", updateNetState);
    return () => {
      window.removeEventListener("load", updateNetState);
      window.removeEventListener("online", updateNetState);
      window.removeEventListener("offline", updateNetState);
    };
  }, []);
  return match[0];
}

let defaultNetworkState = {
  isOnline: true,
  effectiveType: "",
  downlink: 0,
  rtt: 0
};

export {
  defaultNetworkState,
  getNetworkState,
  useNetworkInformation,
}
/* react Not a pure module */
